import { render, staticRenderFns } from "./MdPatientAllergiesOutCome.vue?vue&type=template&id=8e315bb2&"
import script from "./MdPatientAllergiesOutCome.vue?vue&type=script&lang=js&"
export * from "./MdPatientAllergiesOutCome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports